module.exports = __webpack_public_path__ + "img/matthieu_n.b89fa9a9.png";